/* Feedogo: show the whole live picture on phones and tablets (width up to 1024px).
   The page made the camera fill all the height left on screen, so on a portrait phone the 16:9 stream was scaled
   with object-fit:cover and only about a third of its width was visible, for own machines (flv.js <video>) and for
   partner machines (Jessibuca canvas from feedogo-hevc.js) alike. This keeps the camera box at 16:9 instead, so the
   picture fits, and on phones uses the same timestamp crop as desktop (top ~11%) instead of the old top:-64px shift
   and bottom fade. On phones the sound button moves to the bottom right, the record button sits just left of it, and
   the prev/next arrows keep their stacked spot on the right. The live chat gets its own band between the video and
   the portion picker instead of covering the bottom of the picture. It only adds a style to the feeder iframe; it does not touch the player or the page code. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var STYLE_ID = 'feedogo-mobile-video-fit';
  var CSS =
    '@media(max-width:1024px){' +
    'body[data-page="feed"] .hero-grid{grid-template-rows:auto auto!important;height:auto!important}' +
    'body[data-page="feed"] .camera{grid-row:1!important;height:auto!important;aspect-ratio:16/9!important;background:#0b201b}' +
    // live chat: its own band between the video and the portion picker, not on top of the picture
    'body[data-page="feed"] .hero-grid{grid-template-rows:auto auto auto!important}' +
    'body[data-page="feed"] .comments-section{grid-row:2!important;align-self:stretch!important;padding:10px 12px!important;background:#0b2b23!important}' +
    'body[data-page="feed"] .feed-card{grid-row:3!important}' +
    '}' +
    '@media(min-width:621px) and (max-width:1024px){' +
    'body[data-page="feed"] .comments-section .comments-layout{flex-direction:row!important;align-items:flex-end!important;gap:8px!important}' +
    'body[data-page="feed"] .comments-section .comment-list{flex:1 1 auto;min-width:0}' +
    'body[data-page="feed"] .comments-section .comment-compose{flex:none!important;width:auto!important;align-self:flex-end!important}' +
    '}' +
    '@media(max-width:620px){' +
    'body[data-page="feed"] .camera::before{height:38%}' +
    'body[data-page="feed"] .live-video{inset:auto 0 0 0!important;top:auto!important;width:100%!important;height:112.5%!important;object-fit:cover!important;object-position:50% 100%!important;-webkit-mask-image:none!important;mask-image:none!important}' +
    'body[data-page="feed"] .sound-control{top:auto!important;bottom:10px!important;right:10px!important}' +
    'body[data-page="feed"] .camera-arrow{z-index:5}' +
    'body[data-page="feed"] .comments-section .comments-layout{flex-direction:row!important;align-items:flex-end!important;gap:8px!important}' +
    'body[data-page="feed"] .comments-section .comment-list{flex:1 1 auto;min-width:0}' +
    'body[data-page="feed"] .comments-section .comment-compose{flex:none!important;width:auto!important;align-self:flex-end!important}' +
    '}';

  function tick() {
    try {
      var f = document.getElementById(FRAME_ID);
      var d = f && f.contentWindow && f.contentWindow.document;
      if (!d || !d.head || !d.getElementById('liveVideo') || d.getElementById(STYLE_ID)) return;
      var st = d.createElement('style');
      st.id = STYLE_ID;
      st.textContent = CSS;
      d.head.appendChild(st);
    } catch (e) {}
  }

  setInterval(tick, 300);
})();
